import { render, staticRenderFns } from "./map-button.vue?vue&type=template&id=2427a206"
import script from "./map-button.vue?vue&type=script&lang=js"
export * from "./map-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports